import React from 'react';
import { Box, Paper, Tabs, Tab, Button, Typography, CircularProgress, Divider } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import NotificationsOutlinedIcon from '@mui/icons-material/NotificationsOutlined';
import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import AreaTitle from '../../components/areaTitle/AreaTitle';
import PaginationFooter from '../admin/components/PaginationFooter';
import NotificationListItem from '../../header/notifications/NotificationListItem';
import useNotificationsPage, { FILTERS } from './useNotificationsPage';

const EMPTY_TEXT = {
  all: 'Nenhuma notificação por aqui ainda.',
  unread: 'Tudo em dia: nenhuma notificação por ler.',
  action: 'Nenhuma providência pendente.',
  resolved: 'Nenhuma notificação resolvida ainda.',
};

/**
 * Página "Notificações": histórico completo do usuário logado, com filtros e paginação.
 * Clicar num aviso marca como lido e abre o link dele (mesma linha usada no sino).
 */
function Notifications() {
  const navigate = useNavigate();
  const { filter, setFilter, items, pagination, isLoading, setPage, markRead, markAllRead } = useNotificationsPage();

  const handleItemClick = (item) => {
    if (!item.is_read) markRead([item.id]);
    if (item.link) navigate(item.link);
  };

  return (
    <div className="page-content">
      <Box sx={{ mb: 3, display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: 2 }}>
        <AreaTitle
          Title="Notificações"
          Icon={<NotificationsOutlinedIcon />}
          Description="Avisos da agenda e da sua assinatura. Os que pedem providência ficam em destaque até serem resolvidos."
        />
        <Button
          variant="outlined"
          size="small"
          startIcon={<DoneAllIcon />}
          onClick={markAllRead}
          sx={{ textTransform: 'none', flexShrink: 0 }}
        >
          Marcar todas como lidas
        </Button>
      </Box>

      <Tabs
        value={filter}
        onChange={(_, value) => setFilter(value)}
        variant="scrollable"
        allowScrollButtonsMobile
        sx={{ mb: 3, borderBottom: '1px solid #E8ECF0' }}
      >
        {FILTERS.map((option) => (
          <Tab key={option.value} value={option.value} label={option.label} />
        ))}
      </Tabs>

      <Paper elevation={0} sx={{ borderRadius: '12px', border: '1px solid #E8ECF0', overflow: 'hidden' }}>
        {isLoading && items.length === 0 ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
            <CircularProgress size={28} />
          </Box>
        ) : items.length === 0 ? (
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', py: 8, px: 2, color: 'var(--color-text-light)' }}>
            <NotificationsNoneOutlinedIcon sx={{ fontSize: 56, opacity: 0.5, mb: 1.5 }} />
            <Typography variant="body1">{EMPTY_TEXT[filter]}</Typography>
          </Box>
        ) : (
          items.map((item, index) => (
            <React.Fragment key={item.id}>
              {index > 0 && <Divider />}
              <NotificationListItem item={item} onClick={() => handleItemClick(item)} />
            </React.Fragment>
          ))
        )}

        {pagination.total > pagination.limit && (
          <PaginationFooter pagination={pagination} onPageChange={setPage} itemLabel="notificações" />
        )}
      </Paper>
    </div>
  );
}

export default Notifications;
